import React, { useEffect, useState } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import {
  getL2SheetProperty,
  getWorkbookProperty,
  setWorkbookProperty,
} from "../../../WorkbookSlice";
import { RxCross2 } from "react-icons/rx";
import { makeDateHierarchy } from "../../../../../components/VizComponents/Utils/makeDatehierarchy";
import SelectBox from "./FilterConfigCompComponents/SelectBox";

const dateFormatdata = [
  {
    label: "2024-09-01",
    value: "%Y-%m-%d",
  },
  {
    label: "Monday",
    value: "%W",
  },
  {
    label: "Mon",
    value: "%a",
  },
  {
    label: "09-01-2024",
    value: "%m-%d-%Y",
  },
  {
    label: "september 01,2024",
    value: "%M %d, %Y",
  },

  {
    label: "01.09.2024",
    value: "%d.%m.%Y",
  },
];
const yearTypeFormat = [
  {
    label: "Financial",
    value: "FY",
  },
  {
    label: "Calender",
    value: "CY",
  },
];
const yearFormatdata = [
  {
    label: "2024",
    value: "%Y",
  },
  {
    label: "24",
    value: "%Y",
  },
];
const quatersFormatData = [
  {
    label: "Q1-2024",
    value: "%Q-%Y",
  },
  {
    label: "Q1-24",
    value: "%Q-%y",
  },
  {
    label: "Q1",
    value: "Qx",
  },
];
const monthFormatData = [
  {
    label: "September",
    value: "%M",
  },
  {
    label: "Sep",
    value: "%b",
  },
  {
    label: "Sep-24",
    value: "%b-%y",
  },
  {
    label: "September-24",
    value: "%M-%y",
  },
];
const weekFormatData = [
  {
    label: "W1",
    value: "Wx",
  },
];
const timeFormatData = [{ label: "01:00 PM", value: "%h %i %p" }];
const formats = ["Year", "Quarter", "Month", "Week", "Day", "Time"];
const measureOptions = [
  {
    label: "Count",
    value: "COUNT",
  },
  {
    label: "Count Distinct",
    value: "DISTINCT",
  },
];
const getFormatOptions = (dateUnit) => {
  switch (dateUnit) {
    case "Year":
      return yearFormatdata;
    case "Quarter":
      return quatersFormatData;
    case "Month":
      return monthFormatData;
    case "Week":
      return weekFormatData;
    case "Day":
      return dateFormatdata;
    case "Time":
      return timeFormatData;
    default:
      return dateFormatdata;
  }
};

export default function DateComponent(props) {
  const {
    reduxKey,
    Sheetid,
    dataSourceID,
    droppedItem,
    handleClosePopup,
    handleSavePopupDate,
    index: reduxDroppedItemIndex,
  } = props;
  // // console.log(droppedItem);

  // // console.log(reduxKey);

  const [format, setFormat] = useState(
    droppedItem.dateUnit ? droppedItem.dateUnit : "Month"
  );
  const dispatch = useDispatch();
  // // console.log(format);

  const [dateFormat, setDateFormat] = useState(
    droppedItem.dateFormat !== undefined
      ? droppedItem.dateFormat
      : {
          label: "September",
          value: "%M",
        }
  );
  const [yearType, setYearType] = useState(
    droppedItem.yearType ? droppedItem.yearType : "FY"
  );
  // console.log(yearType);
  const [index, setIndex] = useState(0); // Default index
  const [measure, setMeasure] = useState(measureOptions[0].value);
  // console.log(measure);
  const [alreadyExists, setAlreadyExists] = useState(false);
  const nanoId = droppedItem.nanoId ?? nanoid();
  const updatedDateItem = {
    ...droppedItem,
    dateFormat,
    dateUnit: format,
    yearType: yearType,
    nanoId,
  };
  // console.log(updatedDateItem);

  const handleClick = (date) => {
    setDateFormat(date); // Set the date format
    setSelectedDateFormat(date.label); // Update the selected unit
    // console.log(date);
  };
  const handleMeasure = (e) => {
    const selected = measureOptions.find(
      (item) => item.value === e.target.value
    );
    if (selected) {
      setMeasure(e.target.value);
    }
  };
  //n
  const [selectedDateFormat, setSelectedDateFormat] = useState(
    droppedItem.dateFormat !== undefined
      ? droppedItem.dateFormat.label
      : monthFormatData[0].label
  );

  const valueArray = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", reduxKey)
  );
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  useEffect(() => {
    // console.log(droppedItem);
    if ("dateFormat" in droppedItem) {
      // this is an edit scenario
      setAlreadyExists(true);
      setDateFormat(droppedItem.dateFormat);
      setIndex(reduxDroppedItemIndex);
    } else {
      // this is a fresh drop
      setAlreadyExists(false);
    }
  }, []);

  const handleSaveForRowAndGroup = () => {
    // console.log(updatedDateItem);
    let dispactableItemIs;
    if (alreadyExists) {
      // no need create one more date hierarchy dropppedItem is just updating inside query
      dispactableItemIs = updatedDateItem;
    } else {
      // console.log();
      const hierarchyFound = hierarchy.find((hItem) =>
        hItem.hierarchyArray.some((hAItem) => {
          if (hAItem.dataType === "Date") {
            // console.log(hAItem.dateUnit);
            return (
              hAItem.dateUnit === updatedDateItem.dateUnit &&
              hAItem.uuid === updatedDateItem.uuid
            );
          }
          return false;
        })
      );
      if (hierarchyFound) {
        // console.log("hierarchy found");
        const foundedHierarchyItem = hierarchyFound.hierarchyArray.find(
          (hAItem) => {
            return (
              `${hAItem.rename}${hAItem.dateFormat.value}` ===
              `${updatedDateItem.rename}${updatedDateItem.dateFormat.value}`
            );
          }
        );
        // console.log(foundedHierarchyItem);
        dispactableItemIs = updatedDateItem;
      } else {
        const dateHierarchyItem = makeDateHierarchy({
          isDateHierarchyTure: true,
          dataSourceID,
          rowDateItem: updatedDateItem,
        });
        let updatedHeirarchyArray = [...hierarchy, dateHierarchyItem];
        const dateHierarchyFirstItem = dateHierarchyItem.hierarchyArray[0];
        dispactableItemIs = dateHierarchyFirstItem;
        // console.log("hierarchy made");
        // console.log(updatedHeirarchyArray);
        dispatch(
          setWorkbookProperty({
            itemInArray: false,
            key: "hierarchy",
            value: updatedHeirarchyArray, // Use the updated array
          })
        );
      }
    }
    // console.log(dispactableItemIs);
    dispactableItemIs &&
      handleSavePopupDate(dispactableItemIs, alreadyExists, index);
    handleClosePopup();
  };

  const handleSaveForvalueColumns = () => {
    const measureObject = measureOptions.find((item) => item.value === measure);
    // console.log({
    //   ...updatedDateItem,
    //   numberObject: {
    //     decimalPlaces: 2,
    //     factor: 1,
    //     prefix: "$",
    //     sufix: "M",
    //     mode: "Auto",
    //   },
    //   measure: measureObject,
    // });
    let dispactableItemIs = {
      ...updatedDateItem,
      numberObject: {
        decimalPlaces: 2,
        factor: 1,
        prefix: "$",
        sufix: "M",
        mode: "Auto",
      },
      measure: measureObject,
    };
    handleSavePopupDate(dispactableItemIs, alreadyExists, index);
    handleClosePopup();
  };

  const handleyearTypeChange = (e) => {
    // console.log(e.target.value);
    setYearType(e.target.value);
  };

  const renderFormats = (dateUnit) => {
    const formatOptions = getFormatOptions(dateUnit);
    return (
      <div
        className=" border flex flex-col justify-start items-start h-[90%] w-full rounded custom-scroll p-1 gap-2"
        onSelect={(e) => setDateFormat(e.target.value)}
      >
        {formatOptions.map((date, index) => (
          <button
            key={index}
            onClick={() => handleClick(date)}
            className={`cursor-pointer px-2 w-full rounded text-left turncate ${
              selectedDateFormat === date.label ? "bg-blue-950 text-white" : ""
            }`}
          >
            {date.label}
          </button>
        ))}
      </div>
    );
  };

  const handleDateUnitChange = (newDateUnit) => {
    setFormat(newDateUnit);
    const firstItem = getFormatOptions(newDateUnit)[0];
    setSelectedDateFormat(firstItem.label);
    setDateFormat(firstItem);
    // console.log(firstItem.label);
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      if (reduxKey !== "valueColumns") {
        handleSaveForRowAndGroup(); // Call your function here
      } else {
        handleSaveForvalueColumns();
      }
    }
  };

  return (
    <div
      className="fixed inset-0  bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      <div className="bg-white rounded shadow-xl flex flex-col gap-4 w-[25rem]">
        <header className="flex justify-between items-center bg-gray-50 p-2">
          <h3 className=" font-medium cursor-pointer ">
            Format {`[${updatedDateItem.rename}]`}
          </h3>
          <RxCross2 className="cursor-pointer" onClick={handleClosePopup} />
        </header>
        {["rows", "groupByFields"].includes(reduxKey) ? null : (
          <div className="flex items-center justify-normal w-full px-1">
            <SelectBox
              value={measure}
              onChange={handleMeasure}
              optionsArray={measureOptions}
            />
          </div>
        )}
        <div className="flex w-full items-center justify-between border">
          {formats.map((type, index) => (
            <button
              className={`w-[20%] px-2 h-7  border-x ${
                format === type
                  ? "bg-blue-950 text-white"
                  : "bg-white text-black"
              }`}
              onClick={() => handleDateUnitChange(type)}
            >
              {type}
            </button>
          ))}
        </div>
        <section className="flex w-full h-auto items-center justify-start gap-1 p-2">
          <aside className="w-[50%] h-60 border-r border-gray-400 flex flex-col justify-start items-center gap-2 p-1 overflow-x-hidden">
            <h3 className="font-medium w-full text-left"> Popular Formats</h3>
            {renderFormats(format)}
          </aside>
          <aside className="w-[50%] flex flex-col justify-start items-start gap-4 p-1 h-60">
            {["Year", "Quarter"].includes(format) ? (
              <div className="flex flex-col w-full items-center justify-start gap-2">
                <span className="w-full text-left font-medium">Custom :</span>
                <SelectBox
                  value={yearType}
                  onChange={handleyearTypeChange}
                  optionsArray={yearTypeFormat}
                />
              </div>
            ) : null}
            {["Year", "Quarter", "Week"].includes(format) ? (
              <div className="flex flex-col w-full items-center justify-start gap-2">
                <span className="w-full text-left font-medium">Query :</span>
                <input
                  className="border w-full rounded px-1"
                  onChange={(e) =>
                    setDateFormat({
                      label: "Custom format",
                      value: e.target.value,
                    })
                  }
                  value={dateFormat.value}
                ></input>
              </div>
            ) : null}
            <div className="flex flex-col w-full items-center justify-start gap-2">
              <span className="w-full text-left font-medium">
                Format Name :
              </span>
              <div className="border-b w-full px-1">{dateFormat.label}</div>
            </div>
          </aside>
        </section>
        <div className="flex items-center w-full justify-end gap-2 bg-gray-50 p-2">
          <button
            onClick={handleClosePopup}
            className=" border py-1 px-2 rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={
              reduxKey !== "valueColumns"
                ? handleSaveForRowAndGroup
                : handleSaveForvalueColumns
            }
            className="bg-blue-950 text-white py-1 px-2 rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
